module.exports = __webpack_public_path__ + "static/img/exfoliation-01.28817c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/exfoliation-01.jpg
// module id = 265
// module chunks = 1